import { useEffect } from "react";
import { useRequest } from "ahooks";
import { Select } from "antd";
import { department as departmentService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function DepartmentSelect({ value, onChange, code }) {
  const auth = useAuthContext();
  const {
    data = { results: [] },
    loading,
    run,
  } = useRequest((params, token) => departmentService.list(params, token), {
    manual: true,
  });
  useEffect(() => {
    if (auth) {
      const type = auth.roles === "admin" ? 1 : 2;
      run({ department_type: code, page_size: 500 }, auth.token);
    }
  }, [run, auth, code]);

  const optionItems = data.results.map((item) => (
    <Select.Option key={item.id} value={item.id}>
      {item.name}
    </Select.Option>
  ));
  return (
    <Select
      value={value}
      onChange={onChange}
      loading={loading}
      style={{ width: 150 }}
      showSearch
      allowClear
    >
      {optionItems}
    </Select>
  );
}

export default DepartmentSelect;
